module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABNUlEQVQ4T6WTsUoDQRCG/9lcwMraUp/hzt4gwaBBbcwL+AJCbISAFloIKfIunk1O0FIxlydQtLBIFzCBBHLZX/a4Oy8hCae31TL77Tc7u7OCnEPcdqcOwTUga39zcQyiIXeeP9CUktlcEL5OArW1SlS09MeUsm0YJXwU1/NZLdtiAun5Msk8HwoAtKINZ7FslSDNx4KENwL3oXtKslpQPN/fdd7TsihhEooFvSiyYQT3nn9J4ArgmEBr1B/c1GqlYVwmgIQPBR3ru2gWnWB9MiuIE7EnGscHe87LPJ9NQH5pkZPDsv28UAAwOpIsKqE56g9uZ0v45ZdeIqAr00Aujir2W5ZLbAKwAGR9xoTP30imlUVjJzymQkeUbK5qZWp+QsMxDBWexG136xD9z8+kGuEfyDN+AGJD2hfOXwFgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/shipin1.png
// module id = Q7tx
// module chunks = 96